module.exports = __webpack_public_path__ + "static/media/portrait-background.3e3ebf99.jpg";